/**
 * React Query timing configuration.
 *
 * Three-tier freshness strategy based on data churn rate:
 *
 * HIGH CHURN (staleTime: 0) — threads
 *   Always stale, refetches on mount and window focus.
 *
 * MEDIUM CHURN (staleTime: 2 min) — semantic objects, metrics, views, dashboards, playbooks
 *   Collaborative artifacts that others may update. Fresh for 2 min,
 *   then background refetch on next interaction or window focus.
 *
 * LOW CHURN (staleTime: 30 min) — org detail, members, namespaces, datasources,
 *   tables, brains, projects, organizations, user context
 *   Structural or personal data. Refreshes on mutations or hard reload.
 */

/** High churn — always considered stale, refetch on every mount/focus */
export const HIGH_CHURN_STALE_TIME = 0;

/** Medium churn — collaborative data, fresh for 2 minutes */
export const MEDIUM_CHURN_STALE_TIME = 2 * 60 * 1000;

/** Low churn — structural/personal data, fresh for 30 minutes */
export const LOW_CHURN_STALE_TIME = 30 * 60 * 1000;

/** 10 minutes garbage collection — keeps data in memory for instant navigation */
export const GC_TIME = 10 * 60 * 1000;

// Legacy aliases — these map to the new tier system
/** @deprecated Use HIGH_CHURN_STALE_TIME */
export const REALTIME_STALE_TIME = HIGH_CHURN_STALE_TIME;
/** @deprecated Use MEDIUM_CHURN_STALE_TIME */
export const STALE_TIME = MEDIUM_CHURN_STALE_TIME;
/** @deprecated Use LOW_CHURN_STALE_TIME */
export const LONG_STALE_TIME = LOW_CHURN_STALE_TIME;
/** @deprecated Use HIGH_CHURN_STALE_TIME */
export const THREAD_STALE_TIME = HIGH_CHURN_STALE_TIME;
/** @deprecated Use MEDIUM_CHURN_STALE_TIME */
export const VIEW_EXECUTION_STALE_TIME = MEDIUM_CHURN_STALE_TIME;
